/** Срок жизни берём из поля exp токена: ответ обмена его не сообщает; без exp таймер не ставим */

import { getTokenExpiration } from '@/utils/jwt';

/** Обновляем токен заранее, чтобы запрос не успел получить 401 */
export const MM_TOKEN_RENEW_LEAD_MS = 60 * 1000;

/** В фоновой вкладке таймеры замедляются: по возврату берём запас шире таймера обновления */
export const MM_TOKEN_VISIBLE_RENEW_LEAD_MS = 90 * 1000;

type SilentRenewHandler = () => void;

let renewTimerId: number | null = null;
let silentRenewHandler: SilentRenewHandler | null = null;
let visibilityInstalled = false;

export function registerSilentRenewHandler(handler: SilentRenewHandler): void {
  silentRenewHandler = handler;
}

export function readAccessTokenExpiryMs(accessToken: string): number | null {
  if (!accessToken) {
    return null;
  }

  const expiryMs = getTokenExpiration(accessToken);

  if (!expiryMs || expiryMs <= 0) {
    return null;
  }

  return expiryMs;
}

export function shouldRenewForLead(accessToken: string, leadMs: number): boolean {
  const expiryMs = readAccessTokenExpiryMs(accessToken);

  if (expiryMs === null) {
    return false;
  }

  return expiryMs - Date.now() <= leadMs;
}

export function cancelScheduledRenewal(): void {
  if (renewTimerId !== null) {
    clearTimeout(renewTimerId);
    renewTimerId = null;
  }
}

function fireScheduledRenewal(): void {
  renewTimerId = null;

  if (silentRenewHandler !== null) {
    silentRenewHandler();
  }
}

export function scheduleTokenRenewal(accessToken: string): void {
  cancelScheduledRenewal();

  const expiryMs = readAccessTokenExpiryMs(accessToken);

  if (expiryMs === null) {
    return;
  }

  const delayMs = expiryMs - Date.now() - MM_TOKEN_RENEW_LEAD_MS;

  if (delayMs <= 0) {
    return;
  }

  renewTimerId = setTimeout(fireScheduledRenewal, delayMs) as any;
}

function onVisibilityChange(): void {
  if (typeof document === 'undefined' || document.hidden) {
    return;
  }

  if (silentRenewHandler !== null) {
    silentRenewHandler();
  }
}

export function installTokenRenewalWatchers(): void {
  if (visibilityInstalled) {
    return;
  }

  if (typeof document === 'undefined' || !document.addEventListener) {
    return;
  }

  visibilityInstalled = true;
  document.addEventListener('visibilitychange', onVisibilityChange);
}
